module.exports = __webpack_public_path__ + "static/media/maxParties_10_15.2d0b4061.png";